<template>
  <div>
  </div>
</template>
<script>

export default {

  data() {
    return {
    };
  },

  methods: {

  },
  mounted: function () {
    console.debug('login mounted')
    const token = localStorage.getItem("oidc_id_token");
    if (!token) {
      // 未登录，调起登陆
      setTimeout(() => {
       $(".logined").trigger("click")
      }, 1000);
    }
  },



};
</script>
<style>
@import url("../assets/css/common.css");
@import url("../assets/css/index.css");
.reg-product {
  text-decoration: underline #00b0ec;
  color: #00b0ec;
  font-size: 15px;
  margin-top: 10px;
  cursor: pointer;
}
.select-wrap2 {
  width: 53rem;
}

.select-wrap select {
  width: 11rem;
  border: 1px solid rgba(216, 221, 225, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 10px;
  font-size: 15px;
  color: #576371;
  overflow-y: scroll;
}
.vercode {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #0190e1;
  cursor: pointer;
}

.vercode_disable {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #a4a4a4;
  cursor: pointer;
}
.qrcode-img {
  width: 150px;
  height: 150px;
}
</style>
